import { Pipe, PipeTransform } from '@angular/core';
import { ResourcesService } from '../../tunnelsante/services/resources/resources.service';

@Pipe({ name: 'wzI18n', standalone: false })
export class I18nPipe implements PipeTransform {
  constructor(private resourcesService: ResourcesService) {}

  transform(key: string, params?: any | any[]): string {
    return this.resourcesService.getResource(key, params);
  }
}
